var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmacyAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25987_4032",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.729492,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25987_4032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.7295V13.3962L3.83333 9.39618L2.5 5.39618V4.06285H10.9667L11.9333 1.39618L13.5 1.96285L12.7333 4.06285H14.5V5.39618L13.1667 9.39618L14.5 13.3962V14.7295H2.5ZM7.83333 12.0628H9.16667V10.0628H11.1667V8.72951H9.16667V6.72951H7.83333V8.72951H5.83333V10.0628H7.83333V12.0628ZM3.9 13.3962H13.1L11.7667 9.39618L13.1 5.39618H3.9L5.23333 9.39618L3.9 13.3962Z",
    fill: "#63666A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacyAccess);
export default __webpack_public_path__ + "static/media/Pharmacy Access.1c885f8e56f571a7560b11e688232e1b.svg";
export { ForwardRef as ReactComponent };